import { tw } from "~/utils";

interface PulseProps {
  className?: string;
  containerClassName?: string;
}

export const Pulse = ({ className, containerClassName }: PulseProps) => {
  return (
    <div className={containerClassName}>
      <div
        className={tw(
          "bg-neutral-80 h-3 w-full animate-pulse rounded-md",
          className,
        )}
      />
    </div>
  );
};
